angular.module('TetherApp').controller('BroadcastListController', [
    '$scope',
    '$window',
    '$log',
    'broadcastService',
    'campaignService',
    function (
        $scope,
        $window,
        $log,
        broadcastService,
        campaignService
    ) {
        let self = this;

        self.isSendNow = false;
        self.simulateQuery = false;
        self.isDisabled = false;
        self.allLists = undefined;
        self.allExperiences = undefined;
        self.ctrl = undefined;
        self.selectedItem = undefined;
        self.querySearch   = querySearch;
        self.selectedItemChange = selectedItemChange;
        self.searchTextChange   = searchTextChange;
        self.errors = [];
        self.broadcast = {};
        self.message = undefined;
        self.experienceId = undefined;
        self.skipOptinCheck = false;
        self.title = undefined;
        self.sendAfter = undefined;
        self.hourAt = undefined;
        self.minuteAt = undefined;
        self.timeOfDayAt = undefined;
        self.hours = [
            {
                value: 1,
                text: '1'
            },
            {
                value: 2,
                text: '2'
            },
            {
                value: 3,
                text: '3'
            },
            {
                value: 4,
                text: '4'
            },
            {
                value: 5,
                text: '5'
            },
            {
                value: 6,
                text: '6'
            },
            {
                value: 7,
                text: '7'
            },
            {
                value: 8,
                text: '8'
            },
            {
                value: 9,
                text: '9'
            },
            {
                value: 10,
                text: '10'
            },
            {
                value: 11,
                text: '11'
            },
            {
                value: 12,
                text: '12'
            }
        ];
        self.minutes = [
            {
                value: 0,
                text: '00'
            },
            {
                value: 15,
                text: '15'
            },
            {
                value: 30,
                text: '30'
            },
            {
                value: 45,
                text: '45'
            }
        ];
        self.timesOfDay = [
            {
                value: 0,
                text: 'AM'
            },
            {
                value: 1,
                text: 'PM'
            }
        ];

        self.myDate = new Date();
        self.minDate = new Date(
            self.myDate.getFullYear(),
            self.myDate.getMonth(),
            self.myDate.getDate()
        );
        self.maxDate = new Date(
            self.myDate.getFullYear(),
            self.myDate.getMonth() + 2,
            self.myDate.getDate());

        function querySearch (query) {
            let results = query ? self.allLists.filter( createFilterFor(query) ) : self.allLists,
                deferred;
            if (self.simulateQuery) {
                deferred = $q.defer();
                $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }
        }

        function searchTextChange(text) {
            //$log.info('Text changed to ' + text);
        }

        function selectedItemChange(item) {
            //$log.info('Item changed to ' + JSON.stringify(item));
        }

        function createFilterFor(query) {
            let lowercaseQuery = angular.$$lowercase(query);
            return function filterFn(list) {
                return (list.name.toLowerCase().indexOf(lowercaseQuery) === 0);
            };
        }

        self.changeSendType = function () {
            self.errors = [];
        };

        let onUsersLists = function (data) {
            self.allLists = data;
        };

        let onExperiencesList = function (data) {
            self.allExperiences = data;
        };

        let onError = function(reason) {
            self.error = 'Could not fetch the data.';
        };

        self.init = function () {
            campaignService.list(true)
                .then(onCampaign, onError);
            broadcastService.getUsersLists()
                .then(onUsersLists, onError);
        };

        let onCampaign = function (data) {
            self.campaigns = data;
        }

        self.loadExperienceList = function () {
            broadcastService.getExperienceList()
                .then(onExperiencesList, onError);
        }();

        let onSend = function (data) {
            self.sendBroadcastCallBack1();
            self.sendBroadcastCallBack2();
        };

        self.sendBroadcast = function(callback1, callback2) {
            let isValid = true;

            if (self.myDate != undefined && self.myDate != '') {
                if (self.isSendNow) {
                    self.myDate = new Date();
                    if (!$window.confirm(self.sendNowConfirmationText)) {
                        isValid = false;
                    }
                } else {
                    self.myDate.setHours(0);
                    self.myDate.setMinutes(0);
                    self.myDate.setSeconds(0);
                }
                if (!self.isSendNow) {
                    if (self.hourAt == undefined
                        && self.minuteAt == undefined
                        && self.timeOfDayAt == undefined) {
                        self.myDate = null;
                    }
                    if (self.hourAt != undefined && self.hourAt != '' && self.hourAt != 0) {
                        self.hourAt = parseInt(self.hourAt);
                        if (self.timeOfDayAt != undefined
                            && self.timeOfDayAt != ''
                            && self.timeOfDayAt == 1) {
                            if (self.hourAt != 12) {
                                self.hourAt += 12;
                            }
                        }
                        self.myDate.setHours(self.hourAt);
                    }
                    if (self.minuteAt != undefined && self.minuteAt != '' && self.minuteAt != 0) {
                        self.minuteAt = parseInt(self.minuteAt);
                        self.myDate.setMinutes(self.minuteAt);
                    }
                }
                if (self.myDate == null) {
                    self.sendAfter = null;
                } else {
                    self.sendAfter = self.myDate.toMysqlFormat();
                }
            } else {
                self.myDate = undefined;
                self.sendAfter = self.myDate;
            }

            if (isValid) {
                //Shortcode Id
                self.broadcast.shortcode_id = $window.shortcode_id;
                //Experience Id
                self.broadcast.experience_id = self.experienceId;
                //Campaign Id
                self.broadcast.campaign_id = self.campaign_id;
                //Participant List Id
                if (self.selectedItem != undefined
                    && self.selectedItem != null
                    && self.selectedItem.id != undefined
                    && self.selectedItem.id != '') {
                    self.broadcast.participant_list_id = self.selectedItem.id;
                }
                //Message
                if (self.message != undefined && self.message != '') {
                    self.broadcast.message = self.message;
                }
                //Message FR
                if (self.message_fr != undefined && self.message_fr != '') {
                    self.broadcast.message_fr = self.message_fr;
                }
                //Title
                if (self.title != undefined && self.title != '') {
                    self.broadcast.title = self.title;
                }
                //Send After
                if (self.sendAfter != undefined) {
                    self.broadcast.send_after = self.sendAfter;
                }
                self.broadcast.send_now = self.isSendNow;
                self.broadcast.skip_optin_check = self.skipOptinCheck;

                broadcastService.sendBroadcast(self.broadcast)
                    .then(onSend, onSendError);

                self.sendBroadcastCallBack1 = callback1;
                self.sendBroadcastCallBack2 = callback2;
            } else {
                //Set hours back to 12 hour clock
                if (self.hourAt > 12) {
                    if (self.hourAt != 12) {
                        self.hourAt -= 12;
                    }
                }
            }

        };

        let onSendError = function(reason) {
            //Set hours back to 12 hour clock
            if (self.hourAt > 12) {
                if (self.hourAt != 12) {
                    self.hourAt -= 12;
                }
            }
            if (reason.data.hasOwnProperty('errors')) {
                self.errors = [];
                let errors = reason.data.errors;
                for (let prop in errors) {
                    if (errors.hasOwnProperty(prop)) {
                        self.errors.push(errors[prop][0]);
                    }
                }
            }
        };

        /**
         * You first need to create a formatting function to pad numbers to two digits
         **/
        function twoDigits(d) {
            if(0 <= d && d < 10) return "0" + d.toString();
            if(-10 < d && d < 0) return "-0" + (-1*d).toString();
            return d.toString();
        }

        /**
         * and then create the method to output the date string as desired.
         * Some people hate using prototypes this way, but if you are going
         * to apply this to more than one Date object, having it as a prototype
         * makes sense.
         **/
        Date.prototype.toMysqlFormat = function() {
            return this.getUTCFullYear() + "-" + twoDigits(1 + this.getUTCMonth()) + "-" + twoDigits(this.getUTCDate()) + " " + twoDigits(this.getUTCHours()) + ":" + twoDigits(this.getUTCMinutes()) + ":" + twoDigits(this.getUTCSeconds());
        };

        $scope.cancel = function() {
            $scope.$parent.cancel();
        };
    }
]);
